"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ToastContainerProps_1 = require("./ToastContainerProps");
require("./ToastContainer.css");
var styles = require("../ToastContainer/ToastContainer.css");
var Message_1 = require("../Message/Message");
var utils_1 = require("../../../utils/utils");
var ToastContainer = /** @class */ (function (_super) {
    __extends(ToastContainer, _super);
    function ToastContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.messageId = 1;
        _this.state = {
            messages: [],
        };
        _this.addMessage = _this.addMessage.bind(_this);
        _this.removeMessage = _this.removeMessage.bind(_this);
        return _this;
    }
    ToastContainer.getMessageProps = function (message) {
        return {
            data: message.data,
            events: message.events,
            options: message.options,
        };
    };
    ToastContainer.prototype.addMessage = function (message) {
        var _this = this;
        this.setState(function (prevState) { return ({
            messages: __spread(prevState.messages, [_this.createContainerMessage(message)]),
        }); });
    };
    ToastContainer.prototype.removeMessage = function (messageId) {
        this.setState(function (prevState) { return ({
            messages: prevState.messages.filter(function (message) { return message.data.id !== messageId; }),
        }); });
    };
    ToastContainer.prototype.render = function () {
        var _this = this;
        var containerClass = this.getContainerClass();
        var messagesToDisplay = this.state.messages.map(function (message) {
            return (React.createElement(Message_1.default, __assign({ testId: utils_1.default(_this.props.testId, 'Message'), key: message.data.id.toString() }, ToastContainer.getMessageProps(message))));
        });
        return (React.createElement("div", { "data-test-id": this.props.testId, className: containerClass }, messagesToDisplay));
    };
    ToastContainer.prototype.getContainerClass = function () {
        if (this.props.options && this.props.options.direction === ToastContainerProps_1.ToastDirection.DOWNTOP) {
            return [styles.toastMessageContainer, styles.downTop].join(' ');
        }
        else {
            return [styles.toastMessageContainer, styles.topDown].join(' ');
        }
    };
    ToastContainer.prototype.createContainerMessage = function (message) {
        return {
            data: __assign(__assign({}, message.data), { id: this.messageId++ }),
            events: __assign(__assign({}, message.events), { removeFromList: this.removeMessage }),
            options: __assign({}, message.options),
        };
    };
    return ToastContainer;
}(React.Component));
exports.default = ToastContainer;
//# sourceMappingURL=ToastContainer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/ToastContainer/ToastContainer.js
// module id = 1281
// module chunks = 8